import { FileSystem } from "../../../../modules/filesystem";

import { cn } from "@synthesis/shared-utils";

import type { UserRolesGGE } from "../../../roles-context";

type ModelsWidgetProps = {
  className?: string;
  projectId: string;
  roles: UserRolesGGE;
  archivedProject: boolean;
  isIntegration: boolean;
};

export const ModelsWidget = ({ projectId, className, roles, archivedProject, isIntegration }: ModelsWidgetProps) => {
  return (
    <figure className={cn("h-full rounded", className)}>
      <main className="h-full w-full" data-cy="modelsWidget-main-filesystem">
        <FileSystem
          className="h-full w-full"
          onlyModels
          projectId={projectId}
          archivedProject={archivedProject}
          rolesGGE={roles}
          isIntegration={isIntegration}
        />
      </main>
    </figure>
  );
};
